import { useContext } from "react";
import { LanguageContext } from "../contexts/LanguageContext";

/**
 * Hook for accessing translation functions and current language
 * @returns {Object} { t, language, changeLanguage, isRTL }
 */
export const useTranslation = () => {
	const { t, language, changeLanguage, isRTL } = useContext(LanguageContext);

	return { t, language, changeLanguage, isRTL };
};
